import { render, staticRenderFns } from "./ModalLocation.vue?vue&type=template&id=23725035&scoped=true&"
import script from "./ModalLocation.vue?vue&type=script&lang=js&"
export * from "./ModalLocation.vue?vue&type=script&lang=js&"
import style0 from "./ModalLocation.vue?vue&type=style&index=0&id=23725035&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23725035",
  null
  
)

export default component.exports